import { createReducer, on } from '@ngrx/store';
import * as DownloadCollectionActions from './download-collection.actions';

export const DOWLOAD_COLLECTION_FEATURE_KEY = 'downloadCollection';

export interface DownloadCollectionState {
  loading: boolean;
  data: string | null;
  error?: string | null;
}

export const initialState: DownloadCollectionState = {
  loading: false,
  data: null,
  error: null,
};

export const downloadCollectionReducer = createReducer(
  initialState,
  on(DownloadCollectionActions.downloadCollection, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DownloadCollectionActions.downloadCollectionSuccess, (state, { data: _ }) => ({
    ...state,
    loading: false,
    data: 'PDF-Sammlung wurde erfolgreich übertragen. Sie wird im Store nicht gespeichert.',
    error: null,
  })),
  on(DownloadCollectionActions.downloadCollectionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
